<script setup>
  import { useWebStore } from "~/store/web";
import ImageLazy from "~/components/ImageLazy.vue";
  const store=useWebStore();
  </script>
<template>
  <div :class="dark ? 'bgDark' : 'bgLight'" class="pb-5">
    <div class="pt-5 grid mx-auto sm:w-3/4 lg:w-11/12 lg:grid-cols-2 lg:gap-7 xl:w-3/5 2xl:px-7" :class="store.screenSize==='mobile'?'singleColumn gap20':store.screenSize==='desktop'?'twoColumns w1300':['laptop','tabletL'].includes(store.screenSize)?'w1000':''">
      <div class="grid text-left" :class="store.screenSize === 'mobile'? '':'singleColumn'">
        <div class="w-full text-center mb-7 sm:text-left" >
          <ImageLazy v-if="!title" class="w80per" :src="'/'+logo" alt="Logo"/>
          <h3 v-else class="InterMedium text-4xl sm:text-center lg:text-left" :class="dark ? 'orangeText' : ''"> {{ title }}</h3>
          <h3 class="text-2xl InterMedium mt-1 sm:text-center lg:text-left lg:w-5/6" :class="!dark ? 'orangeText' : ''" >{{ slogan }}</h3>
        </div>
        <ImageLazy class="sm:w-3/4 sm:mx-auto lg:w-full" :src="'/'+image" :alt="title"/>
      </div>
      <div class="grid text-center justify-items-end gap-3 sm:text-left">
        <p class="text-xl InterMedium p-4 sm:p-0 sm:text-center sm:mt-6 lg:text-left lg:mt-0">{{ text0 }}</p>
        <ul class="tick-list leftGridElement m0 mx-auto lg:mt-7">
          <li v-for="listItem, index in listItems" :key="listItem" class="text-lg text-left" @click="links!==undefined&&go(links[index])">{{ listItem }}</li>
        </ul>
        <p class="smallText" :class="store.screenSize === 'mobile'?'p30':''">{{ text1 }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductHero",
  props: {
    logo: {
      type: String,
      required: false
    },
    slogan: {
      type: String,
      required: true
    },
    text0: {
      type: String,
      default: ''
    },
    text1: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      required: true
    },
    gallery: {
      type: Array,
      default: () => []
    },
    listItems: {
      type: Array,
      default: () => []
    },
    links:{
      type: Array,
      default:()=>[]
    },
    dark: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: undefined
    },
    largeImage: {
      type: Boolean,
      default: false
    }
  },
  methods:{
    go(where){
      window.location.href = where
    }
  }
}
</script>
